module.exports = __webpack_public_path__ + "img/titan-machine-corp.8a44ae51.png";